import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollListPerquisiteComponentsQueryVariables,
  PayrollListPerquisiteComponentsResponse,
} from './types';

export const listPerquisitesComponentsQuery = gql`
  query PayrollListPerquisiteComponents($status: PerquisiteComponentStatus) {
    payrollListPerquisiteComponents(status: $status) {
      components {
        id
        name
        displayName
        description
        isSystemDefault
        status
        showZero
        visibleToEmployee
      }
    }
  }
`;

const listPerquisitesComponents = (
  queryVariables: PayrollListPerquisiteComponentsQueryVariables,
) => {
  return graphQLApi<
    PayrollListPerquisiteComponentsResponse,
    PayrollListPerquisiteComponentsQueryVariables
  >({
    query: listPerquisitesComponentsQuery,
    queryVariables,
  });
};

export default listPerquisitesComponents;
